var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00007 13.963C3.14822 13.963 0.0371094 10.8519 0.0371094 7.00007C0.0371094 3.14822 3.14822 0.0371094 7.00007 0.0371094C10.8519 0.0371094 13.963 3.14822 13.963 7.00007C13.963 10.8519 10.8519 13.963 7.00007 13.963ZM7.00007 1.51859C3.96304 1.51859 1.51859 3.96304 1.51859 7.00007C1.51859 10.0371 3.96304 12.4816 7.00007 12.4816C10.0371 12.4816 12.4816 10.0371 12.4816 7.00007C12.4816 3.96304 10.0371 1.51859 7.00007 1.51859ZM10.1853 5.74081L9.14822 4.70378L6.18526 7.66674L4.926 6.40748L3.88896 7.44452L6.18526 9.74081L10.1853 5.74081Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.fbb17ef9756a2f199b20f8cd5b1617a4.svg";
export { ForwardRef as ReactComponent };